import { UPDATE_APPLE_BUTTON_ACTION } from './apple';

const defaultState = {};

export default function content(state = defaultState, action = {}) {
  switch (action.type) {
    case UPDATE_APPLE_BUTTON_ACTION:
      return Object.assign({}, state, { signInWithAppleEnabled: action.payload });
    default:
      return state;
  }
}
